import React, { Component } from "react";
import { HashLink as Link } from "react-router-hash-link";
import moment from "moment";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import LightBox from "../ui/LightBox";
import BookingCalendarComponent from "../global/booking-calendar-component";
import ListingReviewsComponent from "./listing-reviews-component";
import ReviewAverageComponent from "../global/review-average-component";
import ContactForm from "../global/forms/contactForm";
import RelevantPosts from "../relevantPosts/component";
import {
  setSelectedListing,
  getSelectedListingById,
  getBookings,
  updateListingViews,
} from "./actions";
import { setBookingInfo } from "../dashboard/bookings/actions";
import { generateFileUrl } from "../../apiHelper";
import { getBookingModifiers } from "../../calendarHelper";
import AttractionsMapComponent from "../global/attractions-map-component";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  EmailIcon,
} from "react-share";
import EmailOptionsModal from "./email-options-modal";
import config, { apiBaseUrl } from "../../config";
import {
  isFavoriteListing,
  removeFavoriteListing,
  addFavoriteListing,
  getUserProfileInfo,
} from "../user/actions";
import ShowSuccessToasts from "../global/successToast";
import ShowErrorToasts from "../global/errorToast";
import { USER_PLACEHOLDER } from "../../constants/images";

import AmenitiesModal from "../amenitiesModal/AmenitiesModal";
import { MAGIC_NUMBER } from "../../constants/magicNumbers";
import ToolTip from "../ui/ToolTip";
import { getNumberWithCommas } from "../../constants/util";
import { canAffirmRefresh } from "../dashboard/bookings/booking-overview-component";
import { AmenitiesArray } from "../dashboard/listing/constants";

const attractionsMapRadiusMeters = 5 * 1609; //converts miles to meters for map
const mapStateToProps = (state) => ({
  listing: state.BrowseListings.selectedListing,
  bookings: state.BrowseListings.selectedListingBookings,
  calendars: state.BrowseListings.selectedListingCalendars,
  global: state.Global,
  favorited: state.User.favorited,
  user: state.User.user,
});

class ListingDetailComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      aboutShowReadMore: true,
      aboutTruncated: true,
      showAllAmenities: false,
      averagePrice: 0,
      contactModalOpen: false,
      shareModalOpen: false,
    };
    this.createBooking = this.createBooking.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.renderSocialShare = this.renderSocialShare.bind(this);
    this.renderListingDetails = this.renderListingDetails.bind(this);
    this.renderListingPosterDetails =
      this.renderListingPosterDetails.bind(this);

    this.getListingExtendedStayInfo =
      this.getListingExtendedStayInfo.bind(this);
    this.getListingWeekendStayInfo = this.getListingWeekendStayInfo.bind(this);
    this.listingSupportsExtendedStay =
      this.listingSupportsExtendedStay.bind(this);
    this.listingSupportsWeekendStay =
      this.listingSupportsWeekendStay.bind(this);
    this.renderExtendedStayInfo = this.renderExtendedStayInfo.bind(this);

    this.isStreamlineListing = this.isStreamlineListing.bind(this);

    this.findPossiblyFeaturedAmenities =
      this.findPossiblyFeaturedAmenities.bind(this);
  }

  isStreamlineListing = () => {
    const { listing } = this.props;
    return !!listing.streamId;
  };

  openModal(type) {
    type === "contact" && this.setState({ contactModalOpen: true });
    type === "share" && this.setState({ shareModalOpen: true });
  }

  closeModal() {
    this.setState({ contactModalOpen: false, shareModalOpen: false });
  }

  setAboutRef = (element) => {
    this.about = element;
    if (element) {
      if (element.clientHeight === element.scrollHeight) {
        this.setState({ aboutShowReadMore: false });
      }
    }
  };

  setAmenitiesRef = (element) => {
    this.amenities = element;
  };

  createBooking(from, to) {
    if (from && to) {
      let { dispatch, history, listing } = this.props;
      from.setHours(16);
      to.setHours(10);
      let bookingRequest = {
        listingId: listing._id,
        startDate: from,
        endDate: to,
        guests: 1,
        hasPets: false,
        selectedAddOns: [],
      };
      dispatch(setBookingInfo(bookingRequest));
      history.push("/listing/" + listing._id + "/booking-options");
    }
  }

  componentWillMount() {
    let { dispatch, listing, match, global } = this.props;
    let { id } = match.params;
    if (listing && id !== listing._id) {
      dispatch(setSelectedListing(null));
    }
    dispatch(getSelectedListingById(id));
    dispatch(getBookings(id));
    dispatch(isFavoriteListing(global.userId, id));
    dispatch(getUserProfileInfo(global.userId));
  }

  componentDidMount() {
    let { dispatch, match } = this.props;
    let { id } = match.params;

    if (id) {
      dispatch(updateListingViews(id, 1));
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.listing && this.props.listing) {
      let that = this;
      setTimeout(() => {
        let showMore = {};
        if (that.about && that.about.clientHeight === that.about.scrollHeight) {
          showMore.aboutShowReadMore = false;
        } else {
          showMore.aboutShowReadMore = true;
        }
        that.setState(showMore);
      }, 240);
    }

    if (
      this.state.averagePrice !== prevState.averagePrice &&
      canAffirmRefresh()
    )
      affirm.ui.refresh();
  }

  displayPrice = (averagePrice) => {
    if (!isNaN(averagePrice)) {
      this.setState({ averagePrice: averagePrice });
    }
  };

  getLightBoxImages = () => {
    let images = [];
    let id = this.props.listing._id;
    let listingPhotos = this.props.listing.photos;

    const isStreamlineListing = this.isStreamlineListing();

    if (listingPhotos && listingPhotos.length > 0) {
      listingPhotos.map((x) => {
        const src = isStreamlineListing ? x : generateFileUrl(x, id);
        images.push({
          src: src,
          height: 4,
          width: 8,
          original: src,
        });
      });
    }
    return images;
  };

  renderFavorites() {
    return (
      <div>
        <section>
          <div>
            <h5>
              {this.props.favorited === true ? "Remove from" : "Add to"}{" "}
              Favorites
            </h5>
          </div>
          <div onClick={this.toggleFavorites}>
            <i
              className={`far fa-heart favorite-icon ${
                this.props.favorited === true ? "favorited" : ""
              }`}
              aria-hidden="true"
            ></i>
          </div>
        </section>
      </div>
    );
  }

  toggleFavorites = () => {
    let { dispatch } = this.props;
    if (this.props.favorited) {
      dispatch(
        removeFavoriteListing(this.props.global.userId, this.props.listing._id)
      );
    } else {
      dispatch(
        addFavoriteListing(this.props.global.userId, this.props.listing._id)
      );
    }
  };

  getListingExtendedStayInfo = (listing) => {
    if (this.listingSupportsExtendedStay(listing))
      return listing.pricing.extended_fee;

    return null;
  };

  getListingWeekendStayInfo = (listing) => {
    if (this.listingSupportsWeekendStay(listing))
      return listing.pricing.weekend_fee;

    return null;
  };

  listingSupportsWeekendStay = (listing) => {
    return (
      !!listing.pricing &&
      !!listing.pricing.weekend_fee &&
      !!listing.pricing.weekend_fee.from &&
      !!listing.pricing.weekend_fee.to
    );
  };

  listingSupportsExtendedStay = (listing) => {
    return (
      !!listing.pricing &&
      !!listing.pricing.extended_fee &&
      !!listing.pricing.extended_fee.from &&
      !!listing.pricing.extended_fee.to
    );
  };

  renderExtendedStayInfo = (listing) => {
    const extendedFee = this.getListingExtendedStayInfo(listing);
    if (!extendedFee) return null;

    const start = moment(extendedFee.from).format(
      MAGIC_NUMBER.CHECK_IN_DATE_FORMAT_MOMENT
    );
    const end = moment(extendedFee.to).format(
      MAGIC_NUMBER.CHECK_IN_DATE_FORMAT_MOMENT
    );

    return (
      <div className="stay-rate-info">
        <strong className="stay-rate-strong">
          {`Extended Stay Rates (${
            MAGIC_NUMBER.EXTENDED_STAY_MIN_DURATION
          }+ days) are available at\
         $${getNumberWithCommas(
           extendedFee.value
         )} per night from ${start} to ${end}.`}
        </strong>
      </div>
    );
  };

  findPossiblyFeaturedAmenities = () => {
    let { listing } = this.props;
    const featured = [];

    for (const amenity of listing.amenities) {
      const starredAmenity = `${amenity}*`;
      if (
        AmenitiesArray.includes(amenity) ||
        AmenitiesArray.includes(starredAmenity)
      )
        featured.push(starredAmenity);
    }

    return featured;
  };

  renderAmenities = () => {
    let { listing } = this.props;

    if (!listing.amenities || !listing.amenities.length) return null;

    let featuredAmenities = listing.amenities.filter(
      (x) => x.slice(-1) === "*"
    );

    return (
      <section className="listing-amenities" id="amenities">
        <h5>Amenities</h5>
        <ul
          style={{ paddingBottom: 155 }}
          ref={this.setAmenitiesRef}
          className="truncated"
        >
          {featuredAmenities.map((name, index) => {
            let displayName = name.slice(0, -1);
            let classname = displayName
              .replace(/[^a-zA-Z]/g, "-")
              .toLowerCase();
            return (
              <li key={index}>
                <span className={`amenity-icon ${classname}`}></span>
                {displayName}
              </li>
            ); /* ` for Chrome debugging */
          })}
        </ul>
        {this.renderShowAll()}
      </section>
    );
  };

  renderReadMore = () => {
    if (this.state.aboutShowReadMore) {
      return this.state.aboutTruncated ? (
        <p
          onClick={() =>
            this.setState((prevState) => ({
              aboutTruncated: !prevState.aboutTruncated,
            }))
          }
        >
          Read More <i className="fas fa-chevron-down"></i>
        </p>
      ) : (
        <p
          onClick={() =>
            this.setState((prevState) => ({
              aboutTruncated: !prevState.aboutTruncated,
            }))
          }
        >
          Read Less <i className="fas fa-chevron-up"></i>
        </p>
      );
    }
    return <p></p>;
  };
  renderShowAll = () => {
    return (
      <p
        onClick={() =>
          this.setState((prevState) => ({ showAllAmenities: true }))
        }
      >
        Show All <i className="fas fa-chevron-down"></i>
      </p>
    );
  };

  renderContactModal(listing) {
    if (!this.state.contactModalOpen) return null;

    return (
      <ContactForm
        onClose={this.closeModal}
        values={{ contactUser: listing.userId, listingId: listing._id }}
      />
    );
  }

  renderShareModal(listing) {
    if (!this.state.shareModalOpen) return null;

    let { user } = this.props;
    return (
      <EmailOptionsModal
        onClose={this.closeModal}
        values={{
          currentUser: user,
          listingId: listing._id,
          exportLink: window.location.toString(),
        }}
      />
    );
  }

  renderSocialShare = (listing) => {
    return (
      <div className="listing-social-media-section">
        <div className="social-media-left">
          <p className="social-text">Share this property on social media</p>
        </div>
        <div className="social-media-right">
          <div className="d-flex align-items-center ">
            <div className="">
              <FacebookShareButton
                className="social-button"
                url={`${window.location.origin}${apiBaseUrl}/share/${listing._id}`}
                quote="Check out this listing on CollegeWeekends.com!"
              >
                <FacebookIcon size={32} round />
              </FacebookShareButton>
            </div>
            <div className="ml-3">
              <TwitterShareButton
                className="social-button"
                url={`${window.location.origin}${apiBaseUrl}/share/${listing._id}`}
                title="Check out this listing on CollegeWeekends.com!"
              >
                <TwitterIcon size={32} round />
              </TwitterShareButton>
            </div>
            <div className="ml-3">
              <button
                className="btn btn-circle"
                onClick={() => {
                  this.openModal("share");
                }}
              >
                <EmailIcon size={32} round />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderListingDetails = (listing) => {
    const extendedStayMessage =
      `This listing provides extended stay rates(for stays that are greater ` +
      `than ${MAGIC_NUMBER.EXTENDED_STAY_MIN_DURATION} nights) during certain times of the year as ` +
      `determined by the Owner. Click or see below for details.`;
    const averagePrice =
      this.state.averagePrice === 0
        ? listing.pricing.baseFee
        : this.state.averagePrice;
    return (
      <div className="col-12 col-md-6 d-flex flex-column details-col">
        <section className="listing-details">
          <span className="marker">
            <i className="fas fa-map-marker-alt"></i> {listing.address.city},{" "}
            {listing.address.state}
          </span>
          <h2>{listing.listingName}</h2>
          <span className="listing-type details">{listing.houseType}</span>
          <div className="listing-specs">
            {listing.bedrooms} Bedrooms | {listing.bathrooms} Bathrooms |{" "}
            {listing.sleeps} Sleeps
          </div>
        </section>
        <section className="listing-price">
          <div>
            <ReviewAverageComponent
              reviews={listing.reviews}
              averageRating={listing.averageRating}
              starsOnly
            />
          </div>
          {!this.isStreamlineListing() && (
            <p>
              <span className="price-bold">
                ${getNumberWithCommas(averagePrice)}
              </span>{" "}
              average/night
            </p>
          )}
          {!this.isStreamlineListing() &&
          listing.bookingSetting === "Instant" &&
          config.affirmEnabled ? (
            <p
              className="affirm-as-low-as affirm-text-link"
              data-page-type="product"
              data-amount={averagePrice * 100}
            ></p>
          ) : null}
          {this.state.averagePrice === 0 && (
            <div className="icon">
              <Link to="#calendar">
                <i className="fas fa-info-circle"></i>
                Select dates below for pricing information.
              </Link>
            </div>
          )}
          {this.listingSupportsExtendedStay(listing) && (
            <ToolTip position="right" message={extendedStayMessage}>
              <i className="fas fa-info-circle" id="stay-rate-icon">
                <Link to="#host-rules-info">
                  “Extended Stay Rates” during certain periods.
                </Link>
              </i>
            </ToolTip>
          )}
        </section>
        <div className="row">
          <div className="col-6">
            {this.props.favorited !== null ? this.renderFavorites() : null}
          </div>
        </div>
      </div>
    );
  };

  renderListingPosterDetails = (listing) => {
    if (!listing.userId) return null;

    return (
      <section>
        <h5>Hosted By</h5>
        <div className="row">
          <div className="col-4 col-sm-2 mt-auto mb-auto">
            <div className="profile-photo">
              <img
                src={
                  listing.userId.profile && listing.userId.profile.photo
                    ? generateFileUrl(
                        listing.userId.profile.photo,
                        listing.userId._id
                      )
                    : USER_PLACEHOLDER
                }
                onError={(e) => {
                  e.target.src = USER_PLACEHOLDER;
                }}
              />
            </div>
          </div>
          <div className="col-8 col-sm-4 mt-auto mb-auto">
            <div className="profile-name">
              {listing.userId.firstName} {listing.userId.lastName.substr(0, 1)}.
            </div>
            <Link to={"/profile/" + listing.userId._id}>
              View {listing.userId.firstName}'s Profile
            </Link>
          </div>
          <div className="col-12 col-sm-6 mt-auto mb-auto text-center text-sm-right">
            <button
              className="btn btn-primary"
              type="button"
              onClick={() => {
                this.openModal("contact");
              }}
            >
              Contact Owner
            </button>
          </div>
        </div>
      </section>
    );
  };

  render() {
    let { listing, calendars, bookings } = this.props;

    if (!listing) return <div>Loading...</div>;

    const { tags } = listing;
    const isStreamlineListing = this.isStreamlineListing();

    let images = this.getLightBoxImages();
    let defaultImage = images.length ? images[0].src : "";

    let extendedFee = null;
    if (this.listingSupportsExtendedStay(listing))
      extendedFee = listing.pricing.extended_fee;

    let weekendFee = null;
    if (this.listingSupportsWeekendStay(listing))
      weekendFee = listing.pricing.weekend_fee;

    return (
      <div className="container-fluid listing-detail-page">
        <ShowSuccessToasts />
        <ShowErrorToasts />
        {this.renderSocialShare(listing)}
        <div className="row two-column">
          <div className="col-12 col-md-6 image-col">
            <section className="image-container">
              <LightBox defaultImage={defaultImage} images={images} carousel />
              <div className="row page-links">
                {!!listing.reviews && (
                  <div className="col">
                    <Link to="#reviews">Reviews</Link>
                  </div>
                )}
                {!!listing.amenities && !!listing.amenities.length && (
                  <div className="col">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState((prevState) => ({
                          showAllAmenities: true,
                        }));
                      }}
                    >
                      Amenities
                    </a>
                  </div>
                )}
                <div className="col">
                  <Link to="#map">Map</Link>
                </div>
              </div>
            </section>
          </div>
          {this.renderListingDetails(listing)}
        </div>
        <section className="listing-about">
          <h5>About the Property</h5>
          <p
            ref={this.setAboutRef}
            className={this.state.aboutTruncated ? "truncated" : "expanded"}
          >
            {listing.listingDetails.about}
          </p>
          {this.renderReadMore()}
        </section>
        {listing.listingDetails.sleepingArrangements && (
          <section className="listing-information">
            <h5>Sleeping Arrangements</h5>
            <p>{listing.listingDetails.sleepingArrangements}</p>
          </section>
        )}
        {this.renderAmenities()}
        <section id="host-rules-info" className="host-rules">
          <h5>Host Rules</h5>
          <ul>
            {listing.listingDetails.petsAllowed ? (
              <li>
                <span className="amenity-icon pets"></span>Pets Allowed
              </li>
            ) : (
              <li>
                <span className="amenity-icon no-pets"></span>No Pets
              </li>
            )}
            {listing.listingDetails.smokingAllowed ? (
              <li>
                <span className="amenity-icon smoking"></span>Smoking Permitted
              </li>
            ) : (
              <li>
                <span className="amenity-icon no-smoking"></span>No Smoking
              </li>
            )}
          </ul>
        </section>
        {this.renderExtendedStayInfo(listing)}
        <section id="calendar">
          {!calendars || !bookings ? (
            <div className="loading-calendar-data">
              Loading calendar data...
            </div>
          ) : (
            <BookingCalendarComponent
              modifiers={getBookingModifiers(
                listing.pricing.overrides,
                calendars,
                bookings
              )}
              baseFee={listing.pricing.baseFee}
              extendedFee={extendedFee}
              weekendFee={weekendFee}
              minNightStay={listing.pricing.minNightStay}
              bookingSetting={listing.bookingSetting}
              submit={this.createBooking}
              location={this.props.location}
              displayPrice={this.displayPrice}
              isStreamlineListing={isStreamlineListing}
              listingId={listing._id}
            />
          )}
        </section>
        {this.renderListingPosterDetails(listing)}
        {!!tags ? (
          <section className="relevant-posts">
            <RelevantPosts tags={tags} />
          </section>
        ) : null}
        <section className="listing-map-container" id="map">
          <h5>Explore {listing.address.city}</h5>
          <div id="places-results" />
          <AttractionsMapComponent
            listings={[listing]}
            center={listing.geometry.coordinates.slice().reverse()}
            zoom="15"
            attractionsRadius={attractionsMapRadiusMeters}
            circle
            underLocalAttrations
          />
        </section>
        <section id="reviews">
          <ListingReviewsComponent listing={listing} />
        </section>
        {listing.amenities && listing.amenities.length && (
          <AmenitiesModal
            isShowing={this.state.showAllAmenities}
            onClose={() => {
              this.setState({ ...this.state, showAllAmenities: false });
            }}
            amenities={listing.amenities}
          />
        )}
        {this.renderContactModal(listing)}
        {this.renderShareModal(listing)}
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps)(ListingDetailComponent));
